var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentCollector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.159,
    height: 46.069,
    viewBox: "0 0 38.159 46.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(3169.25 -6743.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_File_2727963",
    transform: "translate(-3160.756 6743.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M1.386,26.27V1.662H14.915L21.454,8.3,21.011,26.27Z",
    transform: "translate(-0.443 -0.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M46.335,10.64H58.084L64.927,17.8V34.951a2.85,2.85,0,0,1-2.845,2.844H46.335a2.85,2.85,0,0,1-2.845-2.844V13.484A2.85,2.85,0,0,1,46.335,10.64Zm17.473,7.608H58.791a1.187,1.187,0,0,1-1.184-1.184v-5.3H46.336a1.729,1.729,0,0,0-1.724,1.724V34.951a1.73,1.73,0,0,0,1.724,1.724H62.083a1.729,1.729,0,0,0,1.724-1.724v-16.7Z",
    transform: "translate(-43.49 -10.64)",
    fill: "#10002e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x2: 13.612,
    transform: "translate(4.043 11.121)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x2: 11.571,
    transform: "translate(4.043 13.163)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x2: 11.571,
    transform: "translate(4.043 15.204)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x2: 11.571,
    transform: "translate(4.043 17.246)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x2: 8.167,
    transform: "translate(4.043 19.288)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Uploads_Folder_136467",
    "data-name": "noun_Uploads Folder_136467",
    transform: "translate(-3169 6761.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M46.246,23.824H24.122V22.412A1.416,1.416,0,0,0,22.71,21h-11.3A1.416,1.416,0,0,0,10,22.412V46.89A1.416,1.416,0,0,0,11.412,48.3H46.246a1.416,1.416,0,0,0,1.412-1.412V25.237A1.416,1.416,0,0,0,46.246,23.824ZM29.3,37.061v5.126a.471.471,0,0,1-.471.471h-.471a.471.471,0,0,1-.471-.471V37.061L26.5,38.445a.7.7,0,0,1-1,0,.7.7,0,0,1,0-1L28.1,34.858a.7.7,0,0,1,1,0l2.589,2.589a.7.7,0,0,1,0,1,.7.7,0,0,1-1,0Zm6.52,5.592H31.183a.471.471,0,0,1-.471-.471v-.471a.471.471,0,0,1,.471-.471H35.82a2.119,2.119,0,1,0,0-4.237h-.706V36.3a2.639,2.639,0,0,0-3.338-2.5l-.588.151-.235-.565a4.134,4.134,0,0,0-7.927,1.506v.664l-.659.052a2.821,2.821,0,0,0,.193,5.639H26a.471.471,0,0,1,.471.471v.471a.471.471,0,0,1-.471.471H22.559a4.227,4.227,0,0,1-.909-8.374,5.556,5.556,0,0,1,10.356-1.958,4.068,4.068,0,0,1,4.467,3.328,3.527,3.527,0,0,1-.654,7Z",
    transform: "translate(-10 -21)",
    fill: "#10002e",
    stroke: "#eef2fc",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCollector);
export default __webpack_public_path__ + "static/media/documentCollector.35b45097.svg";
export { ForwardRef as ReactComponent };